import React from "react";
import styles from "./style.module.css";
import { Link } from "react-router-dom";
import FooterBottom from "../Footer2/FooterBottom";
function privacy() {

  return (
    <div>
      <div className={styles.LogoDIv}
        onClick={() => (window.location.href = "https://www.brunovisioncare.com/")}
        style={{ cursor: "pointer" }}>
        <div className={styles.LogImg}>
          <img src="Images/Logo-svg2.png" alt="Bruno Vision Care logo" loading="lazy" decoding="async" />
        </div>
      </div>
      <section className={styles.mainPriva}>
        <h1> Privacy and Cookie Policy</h1>
        <div className={styles.paraStart}>
          <p>Effective Date: September 1, 2025</p>
          <p>
            This Privacy Policy applies to the Bruno Vision Care, LLC (
            <b>“BVC”</b>) website,
            <a href="https://www.brunovisioncare.com" target="_blank"  rel="noopener noreferrer">
              {" "}
              www.brunovisioncare.com
            </a>{" "}
            (<b>“Site”</b>) and governs Personal Information collection, use,
            and disclosure.
          </p>
          <p>
            By using our Site, you understand and accept the policies and
            practices described in this Privacy Policy. Each time you visit the
            Site and provide Personal Information to us, you are consenting to
            our disclosure and use of the information provided. This Privacy
            Policy is incorporated into the website’s{" "}
            <Link to="/termsofuse">Terms of Use.</Link>
          </p>
          <p>
            For purposes of this Privacy Policy, <b>“Personal Information”</b>{" "}
            means any information that identifies, relates to, describes, is
            reasonably capable of being associated with, or could reasonably be
            linked, directly or indirectly, with you.
          </p>
          <p></p>

          <h5>1. Personal Information Collection</h5>
          <p>
            We may collect the following types of Personal Information about you
            when you directly provide it to us, automatically when you access
            the Site, or through our vendors:
          </p>
          <ul>
            <li>
              <b>Contact Information and Other Identifiers,</b>
              <span>
                {" "}
                including name, email, phone number, unique personal identifier,
                online identifier, and IP address.
              </span>
            </li>

            <li>
              <b>Professional and Employment-Related Information,</b>{" "}
              <span> including title and company.</span>
            </li>
            <li>
              <b>Content of Communications,</b>{" "}
              <span>
                {" "}
                including Personal Information that you provide when you
                complete our contact form.
              </span>
            </li>

            <li>
              <b>Internet or Other Electronic Network Activity Information,</b>{" "}
              <span>
                {" "}
                including browsing history, search history, and information
                regarding your interaction with our Site.
              </span>
            </li>
          </ul>
          <p>
            We may combine Personal Information that we obtain through the Site
            with information we have obtained from other sources, both online
            and offline.
          </p>
          <p>
            Please keep in mind that if you directly disclose personally
            identifiable information or personally sensitive data through any
            BVC public message or commenting boards, this information may be
            collected and used by others.
          </p>

          <h5>2. Personal Information Use</h5>

          <p>
            We may use and otherwise process Personal Information obtained
            through the Site for the following purposes:
          </p>
          <ul>
            <li>
              <b>Product and Service Delivery and Improvement,</b>
              <span>
                {" "}
                including providing information about our products and services;
                optimizing and improving the Site, products and services; and
                managing accounts and sales.
              </span>
            </li>

            <li>
              <b>Business Operations,</b>
              <span>
                {" "}
                including managing operational and financial activities;
                performing system administration and managing technology;
                identifying prospective customers, partners, and vendors;
                managing our customer, partner, and vendor relationships; and
                otherwise operating our business.
              </span>
            </li>

            <li>
              <b>Site Operations,</b>
              <span>
                {" "}
                including maintaining, operating, and providing access to our
                Site; identifying Site visitors; monitoring and analyzing Site
                usage and trends; evaluating Site performance; repairing or
                improving the Site; and tracking and responding to quality and
                security issues.
              </span>
            </li>

            <li>
              <b>Communications,</b>
              <span>
                {" "}
                including responding to and processing any requests from you;
                better communicating and understanding your needs and how BVC
                can improve to meet these needs; and conducting surveys to
                research your opinion of current and anticipated services.
              </span>
            </li>

            <li>
              <b>Marketing and Advertising,</b>
              <span>
                {" "}
                including distributing marketing and promotional materials;
                measuring the use of our Site and effectiveness of our
                advertising and marketing; understanding how you interact with
                our advertising and marketing, including our emails to you; and
                developing insights to improve our Site and provide our users
                with enhanced features and functionalities.
              </span>
            </li>

            <li>
              <b>Security and Integrity,</b>
              <span>
                {" "}
                including protecting the security and effective functioning of
                our Site and information technology systems; authenticating
                users; and enforcing our policies and terms.
              </span>
            </li>

            <li>
              <b>Legal and Compliance,</b>
              <span>
                {" "}
                including preventing, identifying, investigating, and responding
                to fraud, illegal or malicious activities, and other activity
                that violates or may violate applicable laws, regulations, legal
                process or our policies; managing risks, investigations,
                reporting, and other compliance activities; responding to court
                orders or other government and law enforcement mandates or
                requests; identifying or managing legal actions related to our
                or others’ rights or property; supporting actual or threatened
                claims, defenses, or declarations in a case or before any
                jurisdictional and/or administrative authority, arbitration, or
                mediation panel; fulfilling our legal obligations; and enforcing
                compliance with applicable laws, regulations, or legal processes
                as well as industry standards and our company policies.
              </span>
            </li>
          </ul>

          <h5>3. Personal Information Disclosure</h5>
          <p>
            We may disclose Personal Information obtained through the Site to
            the following parties as described below and for the purposes set
            out above:
          </p>
          <ul>
            <li>
              <b>BVC Affiliates</b>{" "}
              <span> to manage and operate our business.</span>
            </li>
            <li>
              <b>Partners, Suppliers, and Vendors</b>{" "}
              <span>
                {" "}
                that support our operations and perform functions on our behalf,
                including performing statistical analysis, sending email or
                postal mail, providing customer support, providing hosting and
                technology services, and arranging for deliveries.
              </span>
            </li>

            <li>
              <b>Professional Advisors</b>{" "}
              <span>
                {" "}
                that support our business, including by performing audit
                functions and providing legal and other advice.
              </span>
            </li>

            <li>
              <b>Parties for Legal and Compliance Purposes,</b>{" "}
              <span>
                {" "}
                including complying with the law and legal processes served on
                BVC or the Site, such as any subpoena, court order, or
                governmental agency request; protecting the legal rights,
                property, or safety of BVC and others, such as users of the Site
                or the public; exercising and defending legal claims;
                investigating, preventing, or taking action regarding actual or
                suspected illegal activities or fraud; enforcing our terms,
                policies, and contractual agreements; and preventing crime.
              </span>
            </li>

            <li>
              <b>Corporate Transaction Parties</b>{" "}
              <span>
                {" "}
                as part of a company consolidation, merger, acquisition, or sale
                of BVC stock or assets, as well as in the event of insolvency,
                bankruptcy, or receivership in which Personal Information would
                be transferred as an asset of BVC.
              </span>
            </li>
          </ul>

          <h5>
            <span>4.</span> Cookies and Tracking Technologies
          </h5>

          <p>
            The BVC Site uses cookies, and other tracking technologies{" "}
            <b>(“Cookies”)</b> to personalize your online experience; provide
            access to the Site; gather information about your usage patterns
            when you navigate this Site; remember your preferences; and improve
            our Site, products, and services.
          </p>
          <p>
            Your browser may have settings that allow you to transmit a “Do Not
            Track” signal when you visit a website or use online services. Like
            many websites, our website is not designed to respond to “Do Not
            Track” signals received from browsers. To learn more about “Do Not
            Track” signals,{" "}
            <a
              href="https://fpf.org/thank-you-for-visiting-allaboutdnt-com/"
              target="blank"
              rel="noopener noreferrer"
            >
              {" "}
              visit www.allaboutdnt.com.
            </a>
          </p>

          <p>
            Your browser may provide you with the ability to accept or decline
            Cookies. Most web browsers automatically accept Cookies, but you can
            usually modify your browser setting to decline cookies if you
            prefer. If you choose to decline cookies, the Site may not function
            properly. You will need to disable or delete Cookies separately on
            each browser you use.
          </p>

          <h5>5. Linked Websites</h5>
          <p>
            The Site contains links and references to websites controller by
            unaffiliated third parties. BVC encourages you to review the privacy
            statements of other websites you choose to visit that are linked
            from the BVC Site so that you can understand how those websites
            collect, use and share your information. BVC is not responsible for
            the privacy statements or other content on websites outside of the
            BVC Site. Links to other websites or online services do not imply
            our endorsement.
          </p>

          <h5>6. Security of Personal Information</h5>
          <p>
            We take the security of Personal Information seriously and use a
            variety of industry-standard securities to protect Personal
            Information from unauthorized access, use, and/or disclosure.
            Nevertheless, we make no guarantee as to the security of your
            personal information and disclaim, to the fullest extent permitted
            by law, all liability and damages caused by loss, misuse,
            unauthorized access, alteration, disclosure or destruction. We
            encourage you to take any and all available precautionary measures
            to protect Personal Information you submit on this Site.
          </p>

          <h5>7. Users Outside the United States</h5>
          <p>
            By using our Site, you acknowledge your Personal Information may be
            transferred to and processed in jurisdictions outside your own,
            including the United States, as described in this Privacy Policy.
            Please be aware that the data protection laws and regulations that
            apply to your Personal Information transferred to the United States
            or other countries may be different from the laws in your country of
            residence.
          </p>

          <h5>8. Changes to this Privacy Policy</h5>
          <p>
            BVC will occasionally update this Privacy Policy, as indicated by
            the Effective Date. BVC encourages you to periodically review this
            Privacy Policy to be informed of how BVC is processing your Personal
            Information.
          </p>

          <h5>9. Contact Information</h5>
          <p>
            If you have any questions or comments regarding this Privacy Policy,
            please contact BVC at{" "}
            <a
              href="https://mail.google.com/mail/u/0/?view=cm&to=legal@brunovisioncare.com"
              target="blank"
              rel="noopener noreferrer"
            >
              legal@brunovisioncare.com
            </a>
          </p>
        </div>
      </section>
      <FooterBottom />
    </div>
  );
}

export default privacy;
